import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueryStateService {
  private queryState: any;
  originalQueryState = new BehaviorSubject<any>(null);
  constructor() {}

  setQueryState(query: any) {
    this.queryState = query;
  }

  getQueryState(): any {
    return this.queryState;
  }

  clearQueryState() {
    this.queryState = null;
  }
}
